import { FC, useCallback } from 'react';
import { useTranslation } from '@frontend/i18n';
import { pendoTags } from '../../../../../constants';
import { useSteps } from '../../../../../hooks';
import { useSendFormsContext } from '../../../../../providers';
import { DigitalFormsSendingExperienceTracker } from '../../../../../utils';
import DeliveryOption from '../delivery-option/delivery-option.component';

const SendAsKioskQR: FC = () => {
  const { t } = useTranslation('digital-forms-sending-experience');
  const { origin } = useSendFormsContext();
  const { goToNextStep } = useSteps();

  const sendToKioskHandler = useCallback(() => {
    DigitalFormsSendingExperienceTracker.finishSendFormTracking({
      isComplete: true,
      deliveryMethod: 'kiosk',
      origin,
    });
    goToNextStep();
  }, [origin, goToNextStep]);

  return (
    <DeliveryOption
      icon='kiosk-small'
      displayName={t('Send to Kiosk')}
      deliveryMethod='kiosk'
      onClick={sendToKioskHandler}
      trackingId={pendoTags.steps.deliveryMethod.kiosk.select}
    />
  );
};

export default SendAsKioskQR;
